<script setup lang="ts">
import {
    LazyContentPrivacyCs,
    LazyContentPrivacyDe,
    LazyContentPrivacyEn,
    LazyContentPrivacyEs,
    LazyContentPrivacyFr,
    LazyContentPrivacyIt,
    LazyContentPrivacyNl,
    LazyContentPrivacyPl,
    LazyContentPrivacyPt,
    LazyContentPrivacyRo,
    LazyContentPrivacyRu,
} from '#components';
import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { locale, tt } = useTypedI18n();
useSeoMeta({
    title: tt('seo.privacyPolicy.title'),
    ogTitle: tt('seo.privacyPolicy.title'),
    description: tt('seo.privacyPolicy.description'),
    ogDescription: tt('seo.privacyPolicy.description'),
});

// DATA
const currentComponent = computed<Component>(() => {
    const componentByLocale: Record<Locale, Component> = {
        [Locale.CS]: LazyContentPrivacyCs,
        [Locale.DE]: LazyContentPrivacyDe,
        [Locale.EN]: LazyContentPrivacyEn,
        [Locale.ES]: LazyContentPrivacyEs,
        [Locale.FR]: LazyContentPrivacyFr,
        [Locale.NL]: LazyContentPrivacyNl,
        [Locale.IT]: LazyContentPrivacyIt,
        [Locale.PL]: LazyContentPrivacyPl,
        [Locale.PT]: LazyContentPrivacyPt,
        [Locale.RO]: LazyContentPrivacyRo,
        [Locale.RU]: LazyContentPrivacyRu,
    };

    return componentByLocale[locale.value];
});
</script>

<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>
